import { IconDollarBlue, IconGraph } from "app/components/Icon/Icon";
import { PositionMatrixHelper } from "app/helpers/positionMatrixHelper";
import isPublicView from "app/utils/publicViewUtils";
import React, { useState } from "react";
import { SportsNameType } from "../../../../../../utils/const";

type Props = {
  event: any;
  onClickGraph: (...args: Array<any>) => any;
};

const AsianEventIconsBetsGraphs: React.FC<Props> = ({
  event,
  onClickGraph,
}) => {
  const [infoMessageMarketGraph, setInfoMessageMarketGraph] = useState(false);

  return (
    <div className="asian-event__icons-col">
      {event.hasBetsOnEvent && event.sportType === SportsNameType.SOCCER && (
        <span onClick={() => PositionMatrixHelper.onClickPositionMatrix(event)}>
          <IconDollarBlue className="icon-desktop--inactive asian-event__icon" />
        </span>
      )}
      {event["numberOfMarkets"] > 0 && (
        <span
          onClick={onClickGraph}
          className={isPublicView() ? "disabled" : ""}
        >
          <IconGraph className="asian-event__icon asian-event__icon--graph" />
        </span>
      )}
    </div>
  );
};

export default AsianEventIconsBetsGraphs;
